import { useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useToast, humanizeError } from '../shared/Toast'

export default function MedicationForm({ recipientId, medication, onDone, onCancel }) {
  const toast = useToast()
  const editing = !!medication
  const [f, setF] = useState({
    name: medication?.name || '',
    dose: medication?.dose || '',
    timing: medication?.timing || '',
    purpose: medication?.purpose || '',
    prescribing_doctor: medication?.prescribing_doctor || '',
    refill_reminder_date: medication?.refill_reminder_date || '',
    notes: medication?.notes || '',
  })
  const [busy, setBusy] = useState(false)
  const set = (k, v) => setF((c) => ({ ...c, [k]: v }))

  async function save() {
    if (!f.name.trim()) return toast.error('Medication name is required.')
    setBusy(true)
    try {
      const payload = {
        name: f.name.trim(),
        dose: f.dose.trim() || null,
        timing: f.timing.trim() || null,
        purpose: f.purpose.trim() || null,
        prescribing_doctor: f.prescribing_doctor.trim() || null,
        refill_reminder_date: f.refill_reminder_date || null,
        notes: f.notes.trim() || null,
      }
      const res = editing
        ? await supabase.from('medications').update(payload).eq('id', medication.id)
        : await supabase.from('medications').insert({ ...payload, care_recipient_id: recipientId, is_active: true })
      if (res.error) throw res.error
      toast.success(editing ? 'Medication updated.' : 'Medication added.')
      onDone()
    } catch (err) {
      toast.error(humanizeError(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div
      onClick={() => !busy && onCancel()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: 'var(--bg)', width: '100%', maxWidth: 'var(--maxw)', borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: 20, maxHeight: '92dvh', overflowY: 'auto' }}
      >
        <div className="spread" style={{ marginBottom: 12 }}>
          <h2 className="title" style={{ fontSize: 20 }}>{editing ? 'Edit medication' : 'Add medication'}</h2>
          <button onClick={onCancel} style={{ background: 'none', border: 'none', fontSize: 22, color: 'var(--muted)' }}>✕</button>
        </div>
        <div className="stack">
          <div className="field"><label className="label">Name *</label><input className="input" value={f.name} onChange={(e) => set('name', e.target.value)} placeholder="e.g. Metformin" /></div>
          <div className="row" style={{ gap: 10 }}>
            <div className="field grow"><label className="label">Dose</label><input className="input" value={f.dose} onChange={(e) => set('dose', e.target.value)} placeholder="e.g. 500mg" /></div>
            <div className="field grow"><label className="label">Timing</label><input className="input" value={f.timing} onChange={(e) => set('timing', e.target.value)} placeholder="e.g. Twice daily" /></div>
          </div>
          <div className="field"><label className="label">Purpose</label><input className="input" value={f.purpose} onChange={(e) => set('purpose', e.target.value)} placeholder="e.g. Blood sugar" /></div>
          <div className="field"><label className="label">Prescribing doctor</label><input className="input" value={f.prescribing_doctor} onChange={(e) => set('prescribing_doctor', e.target.value)} placeholder="e.g. Dr. Patel" /></div>
          <div className="field"><label className="label">Refill reminder date</label><input type="date" className="input" value={f.refill_reminder_date} onChange={(e) => set('refill_reminder_date', e.target.value)} /></div>
          <div className="field"><label className="label">Notes</label><textarea className="textarea" value={f.notes} onChange={(e) => set('notes', e.target.value)} placeholder="Optional" /></div>
          <button className="btn btn-lg btn-block" onClick={save} disabled={busy}>{busy ? <span className="spinner" /> : editing ? 'Save changes' : 'Add medication'}</button>
        </div>
      </div>
    </div>
  )
}
